var BusinessFormStep;
(function (BusinessFormStep) {
    BusinessFormStep["coreInfo"] = "coreInfo";
    BusinessFormStep["legalAddress"] = "legalAddress";
    BusinessFormStep["additionalQuestions"] = "additionalQuestions";
    BusinessFormStep["representative"] = "representative";
    BusinessFormStep["owners"] = "owners";
    BusinessFormStep["bankAccount"] = "bankAccount";
    BusinessFormStep["documentUpload"] = "documentUpload";
    BusinessFormStep["termsAndConditions"] = "termsAndConditions";
})(BusinessFormStep || (BusinessFormStep = {}));
var BusinessFormServerErrors;
(function (BusinessFormServerErrors) {
    BusinessFormServerErrors["fetchData"] = "Error retrieving business data";
    BusinessFormServerErrors["patchData"] = "Error updating business data";
})(BusinessFormServerErrors || (BusinessFormServerErrors = {}));
var BusinessFormClickActions;
(function (BusinessFormClickActions) {
    BusinessFormClickActions["nextStep"] = "nextStep";
    BusinessFormClickActions["previousStep"] = "previousStep";
    BusinessFormClickActions["submit"] = "submit";
    BusinessFormClickActions["removeOwner"] = "removeOwner";
    BusinessFormClickActions["addOwner"] = "addOwner";
    BusinessFormClickActions["addOwnerForm"] = "addOwnerForm";
    BusinessFormClickActions["updateOwner"] = "updateOwner";
})(BusinessFormClickActions || (BusinessFormClickActions = {}));
var OwnerFormServerErrors;
(function (OwnerFormServerErrors) {
    OwnerFormServerErrors["fetchData"] = "Error retrieving owner data";
    OwnerFormServerErrors["patchData"] = "Error updating owner data";
    OwnerFormServerErrors["postData"] = "Error adding owner data";
})(OwnerFormServerErrors || (OwnerFormServerErrors = {}));
var DocumentFormServerErrors;
(function (DocumentFormServerErrors) {
    DocumentFormServerErrors["fetchData"] = "Error retrieving document data";
    DocumentFormServerErrors["sendData"] = "Error uploading document data";
})(DocumentFormServerErrors || (DocumentFormServerErrors = {}));

export { BusinessFormStep as B, BusinessFormServerErrors as a, BusinessFormClickActions as b };
